import React from 'react'
import Header from '../Component/Header/Header'
import Footer from '../Component/Footer/Footer'
import AboutMain from '../Component/AboutMain/AboutMain'

function About() {
  return (
    <>
     <Header/>
      <AboutMain/>
     <Footer/>
    </>
  )
}

export default About